var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmilySendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "url(#paint0_radial_21124_37052)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21124_37052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2502 26.0675C19.3363 26.3051 19.3363 26.5654 19.2502 26.803L17.3035 33.5602C16.5808 36.0687 19.2649 38.1905 21.5388 36.9082L35.5753 28.9928C37.5589 27.8742 37.5527 25.0155 35.5642 23.9055L21.529 16.0711C19.2495 14.7987 16.5746 16.9323 17.3084 19.4377L19.2502 26.0675Z",
    stroke: "white",
    strokeWidth: 2.625,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4661 26.502H19.6328",
    stroke: "white",
    strokeWidth: 2.625,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_21124_37052",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.3474 15.2473) rotate(71.3582) scale(62.1209 56.1429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6AC55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421276,
    stopColor: "#F73B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60032,
    stopColor: "#D348E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64431,
    stopColor: "#B15EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.712266,
    stopColor: "#47A3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775751,
    stopColor: "#D9F0FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21124_37052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmilySendIcon);
export default __webpack_public_path__ + "static/media/emily-send-icon.26076095.svg";
export { ForwardRef as ReactComponent };